module.exports = __webpack_public_path__ + "static/media/FhatekoJutta.8a2f3c34.mp4";